import { render, staticRenderFns } from "./AdUnitSizeString.vue?vue&type=template&id=505b6e24&scoped=true&"
import script from "./AdUnitSizeString.vue?vue&type=script&lang=ts&"
export * from "./AdUnitSizeString.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505b6e24",
  null
  
)

export default component.exports